/* GG_GLOBAL_TAPE_05: paint the original PNG on one continuous surface. */
(() => {
  if (customElements.get('gg-tape-surface')) return;
  const images = new Map();
  function loadImage(src) {
    if (!images.has(src)) images.set(src, new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => { images.delete(src); reject(new Error('Tape image unavailable')); };
      image.src = src;
    }));
    return images.get(src);
  }
  class TapeSurface extends HTMLElement {
    connectedCallback() {
      this.tape = this.closest('.gg04-png-tape');
      this.canvas = this.querySelector('canvas');
      if (!this.tape || !this.canvas) return;
      const token = this.token = {};
      this.lastSize = '';
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      this.observer = new ResizeObserver(this.queue);
      this.observer.observe(this.tape);
      window.addEventListener('resize', this.queue, {passive:true});
      loadImage(this.dataset.src).then(image => {
        if (!this.isConnected || this.token !== token) return;
        this.image = image;
        this.queue();
      }).catch(() => { /* Keep the original CSS PNG fallback visible. */ });
    }
    paint() {
      if (!this.isConnected || !this.image) return;
      const cssWidth = this.tape.clientWidth, cssHeight = this.tape.clientHeight;
      if (!cssWidth || !cssHeight) return;
      const dpr = Math.max(1, window.devicePixelRatio || 1);
      const width = Math.ceil(cssWidth * dpr), height = Math.ceil(cssHeight * dpr);
      const size = width + ':' + height;
      if (size === this.lastSize) return;
      const context = this.canvas.getContext('2d', {alpha:false});
      if (!context) return;
      this.canvas.width = width;
      this.canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, width, height);
      // The native 1999 x 382 PNG repeats at column 1994.
      // All destination edges share integer physical pixels on this ONE canvas.
      const cropWidth = Math.min(1994, this.image.naturalWidth);
      const cropHeight = this.image.naturalHeight;
      if (!cropWidth || !cropHeight) return;
      const tileWidth = Math.max(1, Math.round(height * cropWidth / cropHeight));
      let start = Math.round((width - tileWidth) / 2);
      while (start > 0) start -= tileWidth;
      for (let x = start; x < width; x += tileWidth) {
        context.drawImage(this.image, 0, 0, cropWidth, cropHeight, x, 0, tileWidth, height);
      }
      this.lastSize = size;
      this.tape.classList.add('gg05-ready');
    }
    disconnectedCallback() {
      this.token = null;
      this.observer?.disconnect();
      if (this.queue) window.removeEventListener('resize', this.queue);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.tape?.classList.remove('gg05-ready');
    }
  }
  customElements.define('gg-tape-surface', TapeSurface);
})();
